export default __webpack_public_path__ + "static/media/manage-teacher-gold.505a3cec.svg";